export const DIPLOMACY_COLORS = Object.freeze({
  self: '#D5B654',
  ally: '#2FB344',
  treaty: '#3B82F6',
  enemy: '#DC5050',
  neutral: '#6B7280',
  unplayed: '#343A40',
  unclaimed: '#1F2937',
})

const KNOWN_STATUSES = new Set(['ally', 'treaty', 'enemy', 'neutral'])

export const buildDiplomacyColorExpression = (snapshot) => {
  const pairs = Object.entries(snapshot?.countries || {})
    .filter(([, relation]) => KNOWN_STATUSES.has(relation?.status))
    .flatMap(([countryId, relation]) => [String(countryId), DIPLOMACY_COLORS[relation.status]])

  const relationColor = pairs.length
    ? ['match', ['to-string', ['get', 'country_id']], ...pairs, DIPLOMACY_COLORS.neutral]
    : DIPLOMACY_COLORS.neutral

  return [
    'case',
    ['==', ['get', 'country_id'], null], DIPLOMACY_COLORS.unclaimed,
    ['==', ['to-string', ['get', 'country_id']], String(snapshot?.country_id ?? '')], DIPLOMACY_COLORS.self,
    ['!=', ['get', 'is_played'], true], DIPLOMACY_COLORS.unplayed,
    relationColor,
  ]
}
